import styled from 'styled-components';
import colors from '../../../../theme/constants/colors';
import pxToRem from '../../../../theme/helpers/pxToRem';
import Typography from '../../../../theme/typography';

const StyledSize = styled.div`
  h4 {
    ${Typography.Subtitle1}
  }

  p {
    ${Typography.Body3}

    &.light-text {
      color: ${colors.darkBlue50};
    }
  }
`;

export const StyledSizeBody = styled.div`
  section {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0;

    &:first-of-type {
      > *:first-child {
        margin-left: -23px;
      }
    }
  }

  .error-text {
    display: block;

    > p {
      display: block;
      padding: ${pxToRem(10)} ${pxToRem(15)};
      ${Typography.Body3}
      color: ${colors.red100};
      margin-top: ${pxToRem(15)};
      background: ${colors.lightOrange};
      border-radius: 4px;
    }
  }

  > *:not(:last-child) {
    margin-bottom: ${pxToRem(5)};
  }

  .light-text {
    ${Typography.Body3}
    color: ${colors.darkBlue50};
  }
`;

export const TextFieldGroup = styled.section`
  span:not(:first-child):not(:last-child) {
    display: inline-block;
    margin: 0 10px;
  }
`;

export const SectionHeader = styled.h5`
  ${Typography.Body2}
  margin-top: ${pxToRem(25)};
`;

export default StyledSize;
